<nav class="game-nav" aria-label="Secciones del juego">
  <!-- Logo (desktop only) -->
  <img
    [src]="game().logoUrl"
    [alt]="game().name"
    class="game-nav__logo"
    loading="lazy"
  />

  <!-- Section links -->
  <ul class="game-nav__list">
    @for (section of sections(); track section.id) {
      <li>
        <button
          class="game-nav__link"
          [class.game-nav__link--active]="activeSection() === section.id"
          (click)="onSectionClick(section.id)"
          type="button"
        >
          {{ section.label }}
        </button>
      </li>
    }
  </ul>

  <!-- CTA (desktop only). Sin categoría no se pinta: el routerLink saldría roto. -->
  @if (game().categorySlug; as categorySlug) {
    <a [routerLink]="['/tienda', categorySlug]" class="game-nav__cta">
      {{ ctaLabel() }}
    </a>
  }
</nav>
